import { useMemo } from 'react'

import { useUnit } from 'effector-react'

import { Tooltip } from '@/components/ui/tooltip'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { $creatorId } from '@/models/creators'
import { openDialog } from '@/models/dialogs'
import { useTriggerRerender } from '@/modules/chatting/hooks/use-trigger-rerender'
import { useChatting } from '@/modules/chatting/state/chatting-provider'
import { TrackedFeatures, trackFeatureUsage } from '@/utils/feature-engagement'

import WorldMapIcon from '../../../icons/world-map.svg'

const timezoneData = [
  {
    name: 'onlineFansContainer',
  },
  {
    name: 'Pacific Time [PT]',
    time: 'Los_Angeles',
  },
  {
    name: 'Central Time [CT]',
    time: 'Chicago',
  },
  {
    name: 'Eastern Time [ET]',
    time: 'New_York',
  },
]

export const GlobalInfo = () => {
  const today = new Date()
  const { onlineCount } = useChatting()
  const creatorId = useUnit($creatorId)

  useTriggerRerender()

  const onlineCountText = useMemo(() => {
    if (!onlineCount || onlineCount.updatedAt + 60 * 1000 < Date.now())
      return '?'

    return onlineCount.count >= 100 ? '100+' : `${onlineCount.count}`
  }, [onlineCount])

  const openCollectionsDialog = () => {
    trackFeatureUsage(TrackedFeatures.CUICollections, creatorId)
    openDialog({
      type: DIALOG_TYPE.COLLECTIONS,
      isPersistent: true,
      config: {
        listId: 'fans-active',
        filters: { online: true },
      },
    })
  }

  return (
    <div className="relative rounded-lg bg-secondary-50 px-4 py-[18px] dark:bg-secondary-600">
      <p className="relative z-10 text-[26px] font-semibold leading-[30px] text-secondary-900 dark:text-white">
        American Timezones
      </p>

      <WorldMapIcon className="absolute bottom-5 left-1.5 right-1.5 top-5 z-0 max-w-full text-secondary-100 dark:text-[#4E4E4F]" />

      <p className="relative z-10 mt-1.5  flex items-center gap-3 text-sm text-secondary-300">
        <span>
          {today.toLocaleString('en-US', {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
          })}
        </span>
        <span className="text-[8px]">&#x2022;</span>
        <Tooltip
          content="See Online Fans"
          asChild
        >
          <button
            className="font-semibold text-primary-400"
            onClick={openCollectionsDialog}
          >
            {onlineCountText} online fans
          </button>
        </Tooltip>
      </p>

      <div className="relative z-10 mt-10 space-y-3 font-medium leading-[19px] text-secondary-900 dark:text-white">
        {timezoneData
          .filter((t) => !!t.time)
          .map((timezone) => (
            <div
              key={timezone.name}
              className="flex justify-between"
            >
              <p>{timezone.name}</p>
              <span>
                {today.toLocaleTimeString('en-US', {
                  timeZone: 'America/' + timezone.time,
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </span>
            </div>
          ))}
      </div>
    </div>
  )
}
